import React, { useMemo } from "react";
import { StyleSheet } from "react-native";

import { type BoxStyle, Box } from "../Box";
import { useTheme } from "../ThemeProvider";

export interface CardSectionProps {
  /**
   * Used to provide a full-bleed by removing the default padding.
   */
  readonly full?: boolean;

  /**
   * Children to render inside the card section.
   */
  readonly children?: React.ReactNode;

  /**
   * Style prop using MADS convention for custom styling.
   */
  readonly sx?: BoxStyle;

  /**
   * Test ID for testing purposes.
   */
  readonly testID?: string;
}

export function CardSection({
  full = false,
  children,
  sx,
  testID,
}: CardSectionProps): React.JSX.Element {
  const theme = useTheme();

  const styles = useMemo(
    () =>
      StyleSheet.create({
        section: full
          ? {
              paddingHorizontal: 0,
            }
          : {
              paddingHorizontal: theme.spacing.s4,
            },
      }),
    [theme, full],
  );

  const sectionStyle: BoxStyle = {
    ...styles.section,
    ...(typeof sx === "object" && sx !== null ? sx : {}),
  };

  return (
    <Box testID={testID} sx={sectionStyle}>
      {children}
    </Box>
  );
}
